//! This file containst the constants for the actions

export const CREATE = "CREATE";
export const FETCH_ALL = "FETCH_ALL";
export const FETCH_POST = "FETCH_POST";
export const UPDATE = "UPDATE";
export const DELETE = "DELETE";
export const LIKE = "LIKE";
export const SHOW_FORM = "SHOW_FORM";
export const LOGOUT = "LOGOUT";
export const AUTH = "AUTH";
export const START_LOADING = "START_LOADING";
export const END_LOADING = "END_LOADING";
export const CMT_START_LOADING = "CMT_START_LOADING";
export const CMT_END_LOADING = "CMT_END_LOADING";
export const COMMENT = "COMMENT";
